import { render, staticRenderFns } from "./DuplicateTemplate.vue?vue&type=template&id=80e435f6&"
import script from "./DuplicateTemplate.vue?vue&type=script&lang=js&"
export * from "./DuplicateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports